import getContentsByLocale from './getContentsByLocale'
import getPackConfigByLocale from './getPackConfigByLocale'
import getLodgingTypesByLocale from './getLodgingTypesByLocale'
import { LocaleContents } from '../contents/contents'
import { LocalePackConfig } from '../config/pack-config'
import { LocaleLodgingTypeConfig } from '../config/lodging-type-config'
import { LocaleEnum } from '../enums/LocaleEnum'
import { LangEnum } from '../enums/LangEnum'

export type ConfigForLocale = {
    contents: LocaleContents
    packageValues: LocalePackConfig
    lodgingTypes: LocaleLodgingTypeConfig
}

function getConfigForLocale(locale: string, lang: string | undefined): ConfigForLocale {
    if (!locale) throw new Error('locale is mandatory in getConfigForLocale')

    // If the locale is cse, check the lang 
    const formattedLocale: string = locale === LocaleEnum.CSE? ( lang === LangEnum.NL ? LocaleEnum.NL : LocaleEnum.FR) : locale.replaceAll('-', '_')

    const contents: LocaleContents = getContentsByLocale(formattedLocale)
    const packageValues: LocalePackConfig = getPackConfigByLocale(formattedLocale)
    const lodgingTypes: LocaleLodgingTypeConfig = getLodgingTypesByLocale(formattedLocale)

    return {
        contents,
        packageValues,
        lodgingTypes
    }
}

export default getConfigForLocale
